import { Button } from '@octane/spark'
import styled from 'styled-components'

export const Logo = styled.img`
    width: auto;
    height: 54px;
    flex-shrink: 0;
`

export const Banner = styled.div`
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 12px 16px;
    background: #000000;

    @media (max-width: 768px) {
        align-items: stretch;
        flex-direction: column;

        ${Logo} {
            align-self: flex-start;
        }
    }
`

export const TextSection = styled.div`
    flex: 1;
    margin-left: 24px;
`

export const Title = styled.p`
    margin: 0 0 4px;
    color: #ffffff;
    font-family: 'Open Sans', sans-serif;
    font-size: 16px;
    font-weight: 400;
    line-height: 20px;
`

export const Description = styled.p`
    margin: 0;
    color: #ffffff;
    font-family: 'Open Sans', sans-serif;
    font-size: 14px;
    line-height: 20px;
`

export const CtaButton = styled(Button)`
    height: 40px;
    background: #ffd200;
    border-color: #ffd200;
    color: #000000;
    font-family: 'Nunito Sans', sans-serif;
    font-size: 16px;
    font-weight: 700;
    white-space: nowrap;

    &:hover {
        background: #e6bd00;
        border-color: #e6bd00;
        color: #000000;
    }

    &:active {
        background: #ffd200;
        border-color: #ffd200;
        color: #000000;
    }

    @media (max-width: 768px) {
        width: 100%;
    }
`
